// extracted by mini-css-extract-plugin
export var lg = "_hg-7";
export var md = "_hg-6";
export var placeholderContainer = "_hg-1";
export var placeholderIcon = "_hg-2";
export var productImage = "_hg-0";
export var sm = "_hg-5";
export var xl = "_hg-8";
export var xs = "_hg-4";
export var xxs = "_hg-3";